import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../../../routes';
import { AppState } from '../../../store';
import Label16 from '../../../theme/labels/Label16';
import Label24 from '../../../theme/labels/Label24';
import InviteDoneeForm from '../components/inviteDonee/InviteDoneeForm';
import SignupContentWrapper from '../components/SignupContentWrapper';
import { useRouteConfig } from '../utils/useRouteConfig';
import { textFieldWidth } from '../components/styles';
import { useTranslation } from 'react-i18next';
import SampleInviteModal from '../components/inviteDonee/SampleInviteModal';
import Link from '@material-ui/core/Link/Link';
import { pushEvent } from '../../../utils/clevertapUtils';
import { PAGE_INVITE_DONEE } from '../../../utils/clevertapEvents';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        inviteDoneeStyles: {
            maxWidth: textFieldWidth,
            margin: '0 auto',
            marginTop: 77,
            '& .heading': {
                marginBottom: theme.spacing(3),
            },
            '& .subHeading': {
                marginBottom: theme.spacing(2),
            },
        },
    }),
);

const heading = 'Who should we reach out to?';
const subHeading =
    'Invite an officer of your organization to create a Givelify account.';

const InviteDonee: React.FC = () => {
    const push = useNavigate();
    const { inviteDoneeStyles } = useStyles();
    const { t } = useTranslation();
    const [open, setOpen] = useState<boolean>(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const signup = useSelector((state: AppState) => state.Signup);
    const { previous } = useRouteConfig(PATH.SIGNUP.STEPS.INVITE_DONEE);

    useEffect(() => {
        pushEvent(PAGE_INVITE_DONEE);
    }, []);

    useEffect(() => {
        console.log('signup: ', signup);
    }, [signup]);

    if (!signup.organizationName) {
        push(previous);
        return null;
    }

    return (
        <SignupContentWrapper
            showCloseButton={true}
            heading=""
            subHeading={undefined}
            stepInfo={undefined}
            backUrl={previous}
        >
            <div className={inviteDoneeStyles}>
                <Label24 className="heading">{heading}</Label24>
                <Label16 className="subHeading">{subHeading}</Label16>
                <Link onClick={handleOpen}>
                    {t('signup.inviteDonee.seeSampleInvite')}
                </Link>
                <SampleInviteModal open={open} handleClose={handleClose} />
                <InviteDoneeForm previous={previous} />
            </div>
        </SignupContentWrapper>
    );
};

export default InviteDonee;
